var chunkMapping = {
	"0": [
		4667
	],
	"3": [
		4071,
		4601
	],
	"78": [
		5101
	],
	"163": [
		5188
	],
	"164": [
		5189
	],
	"167": [
		5192
	],
	"168": [
		5193
	],
	"169": [
		5194
	],
	"170": [
		5195
	],
	"171": [
		5196
	],
	"172": [
		5197
	],
	"173": [
		5198
	],
	"174": [
		5199
	],
	"175": [
		5200
	],
	"176": [
		5201
	],
	"177": [
		5202
	],
	"178": [
		5203
	],
	"179": [
		5204
	],
	"180": [
		5205
	],
	"181": [
		5206
	],
	"182": [
		5207
	],
	"183": [
		5208
	],
	"184": [
		5209
	],
	"185": [
		5210
	],
	"186": [
		5211
	]
};
var idToExternalAndNameMapping = {
	"4071": [
		"default",
		"./nuorder-components",
		3687
	],
	"4601": [
		"default",
		"./helios-components",
		3687
	],
	"4667": [
		"default",
		"./Containers",
		3597
	],
	"5101": [
		"default",
		"./OrderlessInvoices",
		3597
	],
	"5188": [
		"default",
		"./AsyncEventTracker",
		3597
	],
	"5189": [
		"default",
		"./HostWrapper",
		3597
	],
	"5192": [
		"default",
		"./CheckoutV3",
		3597
	],
	"5193": [
		"default",
		"./CheckoutConfirmation",
		3597
	],
	"5194": [
		"default",
		"./ContactCreditCards",
		3597
	],
	"5195": [
		"default",
		"./AuditDialog",
		3597
	],
	"5196": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3597
	],
	"5197": [
		"default",
		"./InvoiceDialog",
		3597
	],
	"5198": [
		"default",
		"./PaymentDueModal",
		3597
	],
	"5199": [
		"default",
		"./PaymentModal",
		3597
	],
	"5200": [
		"default",
		"./PaymentHistory",
		3597
	],
	"5201": [
		"default",
		"./PaymentConfigurations",
		3597
	],
	"5202": [
		"default",
		"./PaymentPreferences",
		3597
	],
	"5203": [
		"default",
		"./ManagePaymentProcessing",
		3597
	],
	"5204": [
		"default",
		"./MobilePaymentsWrapper",
		3597
	],
	"5205": [
		"default",
		"./PayPage",
		3597
	],
	"5206": [
		"default",
		"./Challenge",
		3597
	],
	"5207": [
		"default",
		"./ManagePaymentMethods",
		3597
	],
	"5208": [
		"default",
		"./LightspeedReports",
		3597
	],
	"5209": [
		"default",
		"./ActivateLightspeedPayments",
		3597
	],
	"5210": [
		"default",
		"./MarketingLandingPage",
		3597
	],
	"5211": [
		"default",
		"./ShippingPromotionsListContainer",
		3597
	]
};
var idToRemoteMap = {
	"4071": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3687
		}
	],
	"4601": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3687
		}
	],
	"4667": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5101": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5188": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5189": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5192": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5193": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5194": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5195": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5196": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5197": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5198": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5199": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5200": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5201": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5202": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5203": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5204": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5205": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5206": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5207": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5208": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5209": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5210": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5211": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}